import type { SVGProps } from "react";

export function IconWhiteGlobe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M58.072 24.9561L54.2502 28.5L47.5002 20.85H32.3003V16.8H37.7003L45.8528 8.8198M58.072 24.9561C58.6772 27.2017 59 29.5631 59 32C59 46.9117 46.9117 59 32 59C27.6895 59 23.6149 57.9899 20 56.1934M58.072 24.9561C56.2314 18.127 51.7793 12.3692 45.8528 8.8198M45.8528 8.8198C41.8028 6.39424 37.0642 5 32 5C28.8339 5 25.7951 5.54494 22.9723 6.54615M22.9723 6.54615L15 21.15H10.45V30.95L5.05263 33.6996M22.9723 6.54615C12.5001 10.2605 5 20.2544 5 32C5 32.5708 5.01772 33.1375 5.05263 33.6996M5.05263 33.6996C5.23377 36.616 5.8779 39.407 6.91239 42M6.91239 42H13L20 49V56.1934M6.91239 42C9.38097 48.1876 14.0724 53.2477 20 56.1934M34.6997 37.4H27.9497V27.25L32.3747 25.25H42.7997L48.1997 33.35L44.1497 40.775L40.0997 48.2H34.6997V42.8V37.4Z"
        stroke="#23232C"
        strokeWidth="1.5"
      />
    </svg>
  );
}
